module.exports = __webpack_public_path__ + "eb856812b86c1668e9ca8b9043813c8e.png";